import { ResultOf } from "gql.tada";
import type { GetRootNavigationItem } from "@queries/GetRootNavigationItem";

type RootNavigationItem = Exclude<
  ResultOf<typeof GetRootNavigationItem>["navigationItemCollection"],
  null
>["items"][0];

export type NavigationProps = {
  root: RootNavigationItem;
  loading: boolean;
  isOverFooter?: boolean;
};

// Flattened page info for navigation use
export type NavPageInfo = {
  slug: string | null;
  title: string | null;
  navigationImage: { url: string | null; title: string | null } | null;
  navigationAlternateLabel: string | null;
  navigationAccessibilityLabel: string | null;
};

// Helper to extract navigation fields from any page archetype navigation item.
// All page archetypes (Homepage, ProductPage, etc.) have slug, title, etc. directly.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getNavPageInfo(item: any): NavPageInfo | null {
  if (!item || item.__typename === "NavigationItem") return null;
  if (!item.slug && !item.title) return null;
  return {
    slug: item.slug ?? null,
    title: item.title ?? null,
    navigationImage: item.navigationImage ?? null,
    navigationAlternateLabel: item.navigationAlternateLabel ?? null,
    navigationAccessibilityLabel: item.navigationAccessibilityLabel ?? null,
  };
}

const getSubmenuItems = (root: RootNavigationItem, index: number) =>
  root?.itemsCollection?.items
    .filter((item) => item?.__typename === "NavigationItem")
    .map((item) =>
      item.itemsCollection?.items.filter(
        (item) => item && item.__typename !== "NavigationItem"
      )
    )[index];

export type SubmenuItems = ReturnType<typeof getSubmenuItems>;
